type BooleanFlag = {
  label: string;
  type: "boolean";
  defaultValue: boolean;
};

// Future: add DropdownFlag here, e.g.:
// type DropdownFlag<T extends string> = { label: string; type: "dropdown"; options: readonly T[]; defaultValue: T; };

export type FlagDefinition = BooleanFlag;

export const FLAGS = {
  customizableEmails: {
    label: "Customizable email content settings",
    type: "boolean",
    defaultValue: false,
  },

  previewShellV2: {
    label: "New sidebar & topbar preview (admin only)",
    type: "boolean",
    defaultValue: false,
  },
} satisfies Record<string, FlagDefinition>;

export type FlagKey = keyof typeof FLAGS;
export type FlagValue<K extends FlagKey> = (typeof FLAGS)[K]["defaultValue"];
